import {mediaServicesAvailable} from '@netx/core-share-media-service/enablers';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	PermissionName,
	currentUserHasAccess,
} from '@netx/core-permissions-next/enablers';
import {currentCartIsEmpty} from './currentCartIsEmpty';

// TODO: this is incomplete at the moment... more, it is a holdover for react until we get the share menu
// reworked one day
export const canShareCurrentCart = () => {
	if (currentCartIsEmpty()) return false;

	if (
		currentUserMeetsUserLevel(UserLevel.DIRECTOR) &&
		mediaServicesAvailable()
	) {
		return true;
	}

	if (!currentUserMeetsUserLevel(UserLevel.CONSUMER)) return false;
	return currentUserHasAccess(PermissionName.CREATE_SHARE_LINKS);
	// it should be safe (atm) to assume that if this action is not available, then none of the other actions would be
	// return (
	// 	(currentCartIsNotEmpty() &&
	// 		currentUserMeetsUserLevel(UserLevel.DIRECTOR) &&
	// 		mediaServicesAvailable()) ||
	// 	// share:assetSet:token -> matrix: 'download',
	// 	// share:assetSet:media:service -> [mediaServicesEnabled, downloadOptionSelected], matrix: 'download',
	// 	// share:token:embed -> [canEmbed], matrix: 'download',
	// 	(currentUserMeetsUserLevel(UserLevel.CONSUMER) &&
	// 		currentUserHasAccess(PermissionName.CREATE_SHARE_LINKS))
	// );
};

export default canShareCurrentCart;
